import { createApi } from "@reduxjs/toolkit/query/react";

import { createServiceBaseQuery } from "../../client/serviceBaseQuery";

export interface QueryHistoryDTO {
  id: string;
  accountId: number;
  clientId: string | null;
  clientTitle: string | null;
  queryText: string;
  executionStatus: string;
  errorMessage: string | null;
  executionTimeMs: number;
  rowsReturned: number | null;
  limitValue: number | null;
  offsetValue: number | null;
  traceId: string | null;
  executedAt: string;
}

export interface QueryHistoryParams {
  status?: string[] | undefined;
  clientId?: string[] | undefined;
  page?: number | undefined;
  size?: number | undefined;
  orderBy?: string | undefined;
  orderDir?: "asc" | "desc" | undefined;
  startDate?: string | undefined;
  endDate?: string | undefined;
}

export const queryHistoryService = createApi({
  reducerPath: "queryHistoryService",
  baseQuery: createServiceBaseQuery("orpheusUri"),
  tagTypes: ["QueryHistory"],
  refetchOnMountOrArgChange: 60,
  endpoints: (builder) => ({
    getQueryHistory: builder.query<QueryHistoryDTO[], QueryHistoryParams>({
      query: ({
        status,
        clientId,
        page = 0,
        size = 100,
        orderBy,
        orderDir,
        startDate,
        endDate,
      }) => {
        const params = new URLSearchParams();

        if (status && status.length > 0) {
          status.forEach((s) => params.append("status", s));
        }

        if (clientId && clientId.length > 0) {
          clientId.forEach((id) => params.append("clientId", id));
        }

        params.append("page", page.toString());
        params.append("size", size.toString());

        if (orderBy) {
          params.append("orderBy", orderBy);
        }
        if (orderDir) {
          params.append("orderDir", orderDir);
        }

        if (startDate) {
          params.append("startDate", startDate);
        }
        if (endDate) {
          params.append("endDate", endDate);
        }

        return `/api/query-history?${params.toString()}`;
      },
      providesTags: [{ type: "QueryHistory", id: "LIST" }],
    }),
  }),
});

export const { useGetQueryHistoryQuery, useLazyGetQueryHistoryQuery } =
  queryHistoryService;
